import { render, staticRenderFns } from "./package-tracking-number.vue?vue&type=template&id=089e4e9a&scoped=true"
import script from "./package-tracking-number.vue?vue&type=script&setup=true&lang=js"
export * from "./package-tracking-number.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089e4e9a",
  null
  
)

export default component.exports